import { Component, Inject, OnInit,forwardRef } from '@angular/core';
import { Router } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUploader } from 'ng2-file-upload';
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CompletionTriggerKind } from 'typescript';
import { DefineErrorComponent } from '../define-error/define-error.component';
import { C, E, T } from '@angular/cdk/keycodes';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIcon } from '@angular/material/icon';
// import { noUndefined } from '@angular/compiler/src/util';
import { ConnectableObservable } from 'rxjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectSubSystemComponent } from '../../boiler-configurator/select-sub-system/select-sub-system.component';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
//import { eventNames } from 'process';
@Component({
  selector: 'app-define-asset',
  templateUrl: './define-asset.component.html',
  styleUrls: ['./define-asset.component.scss'],
  standalone: true,
  imports: [MatCheckboxModule,NgbModule,FormsModule,CommonModule,ReactiveFormsModule,MatRadioButton,MatRadioGroup,MatButtonModule, MatIcon, MatSlideToggleModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectSubSystemComponent),
      multi: true
    }
  ]
})
export class DefineAssetComponent implements OnInit {
  // positions = this._formBuilder.group({
  //   frame: false,
  //   DE: false,
  //   NDE: false,
  // });
  // positionswithmotor = this._formBuilder.group({
  //   frame: false,
  //   DE: false,
  //   NDE: false,
  // });

  tempValue: any;
  assetName: any;
  siteID: any;
  selectedDropDownElement: any = 1;
  applicationNewID: any;
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL + 'uploads/';
  public addAssetsUrl = BaseUrlConstantsService.ADD_ASSETS;
  public assetsBearingUrl = BaseUrlConstantsService.ASSETS_BEARING;
  public clientDeviceUrl = BaseUrlConstantsService.CLIENT_DEVICES;
  public allSitesUrl = BaseUrlConstantsService.GET_SITES;
  public middleware_url = BaseUrlConstantsService.BASE_MIDDLEWARE_SELF;
  public deviceStatusURL = BaseUrlConstantsService.INVENTORY_URL;
  public createBearingNumber = BaseUrlConstantsService.ASSETS_CREATE_BEARING;
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public deviceTypeUrl = BaseUrlConstantsService.DEVICE_TYPE;
  public imageAssetUploadUrl = BaseUrlConstantsService.ASSET_IMAGE_UPLOAD;
  public imageUpdateInfoUrl = BaseUrlConstantsService.UPDATE_IMAGE_INFO;
  public assetsUrl = BaseUrlConstantsService.ASSETS_DATA;
  public assetsUrlEdit = BaseUrlConstantsService.ASSETS_DATA_EDIT;
  public updateAssetsUrl = BaseUrlConstantsService.UPDATE_ASSETS;
  public odrValueHigh: any;
  public cloudPushRateAnomaly: any;
  public cloudAnomalyCounter: any;
  public cloudPushrateHigh: any;
  public scanRateValue: any;
  public invalidFrequencyValue: boolean;
  public filterdOptions = [];
  public selectedTemplateView: any = [];
  public assetTemplateID: any;
  public ivInventoryMsg: any = "";
  public preDeBearingNumber: any;
  public atApplicationName: string = "";
  public atSiteName: string = "";
  public inputFiledChanges: any = [];
  public preNdeBearingNumber: any;
  public applicationID: any;
  public existedInventoryID: any;
  public serialNumber: any;
  public templateCollection: any = [];
  public isItAccelroDevice: boolean;
  public currentFormCount: any = 1;
  public datafreq: any = "";
  public odrValue: string = "";
  public inputFieldLength: any = [];
  public connectedMacAddress: any;
  public uploader: FileUploader;
  public variableRPMToggle: string = 'fixed';
  public connectionInputProxy: boolean;
  public imagePath;
  public imgURL: any;
  public passwordSsid: any = "";
  public callMqttEnable: boolean = false;
  public isTextFieldType: boolean = false;
  public bearingNumbers: any = [];
  public message: string;
  public visible = true;
  public selectable = true;
  public isHorizontalView: boolean = true;
  public removable = true;
  public addOnBlur = true;
  public mx_txt_msg: string = "";
  public pid: any;
  public showList: boolean;
  public emptyMsg: boolean;
  public pageRouteRef: string;
  public lastPageRef: string;
  public fromDataArray: any = [];
  public showUpdateBtn: boolean;
  public showEditUsertxt: string;
  public showSavebtn: boolean;
  public ENV_TYPE: string;
  public deviceTypeID: any;
  public uForm: any;
  public allDevices: any;
  public fromCounter: number = 0;
  public sitesList: any;
  public groupList: any;
  public ssidUser: any = "";
  public selectedSiteID: any;
  public InventoryIDValue: any = "";
  public siteIDEditCase: any;
  public insertClass = ['A', 'B', 'F', 'H'];
  public insertClassWinding = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'];
  public assetsID: any;
  public percentDone = 0;
  public uploadSuccess: boolean;
  public fileName = '';
  public url: any;
  public userId: any;
  public assetMasterInfo: any = {};
  public today: any;
  public myDate: any;
  public id: any;
  public updateDataReq: any = false;
  public showCancelBtn: boolean;
  public _imgUrl: any = "./assets/img-new/default_user.png";
  public showEnabledSaveBtn = true;
  public preValueApplication: any;
  public showDisabledSaveBtn: boolean;
  public showEnableUpdateBtn: boolean;
  public showDisabledUpdateBtn: boolean;
  public _imageId = null;
  public connectionInput: boolean = true;
  public userID: any;
  public tempValuesArr: any = [];
  public beltLength: any;
  public fable: boolean = false;
  public driveVisibility: boolean;
  public assetDetailForm: boolean;
  public gearDetailForm: boolean;
  public selectedAssetType: string = "MOTOR";
  public driveType: string = "DIRECT";
  public adminID: any;
  public isDisabled: boolean = false;
  public beltData: any = [];
  public onOffStatus: string = "";
  public functionDelay;
  public breadcrumbsArray: any = [{
    page_ref: 'device-reports',
    page_title: 'Assets'
  }, {
    page_ref: '#',
    page_title: 'Create Asset'
  }];

  public typesofdevice = ["MOTOR", "GEAR BOX", "PUMP", "FAN/BLOWER", "COMPRESSOR", "JOURNALBEARING"];
  public driventypesofdevice = ["GEAR BOX", "PUMP", "FAN/BLOWER", "COMPRESSOR", "JOURNALBEARING"];
  public selecteddevice = "";
  public selecteddevicewithmotor = "";
  public opensecondimage: boolean;
  public devicewithDE: boolean=false;
  public devicewithNDE: boolean=false;
  public devicewithFrame: boolean=false;
  public SecondDevicewithDE: boolean;
  public SecondDevicewithNDE: boolean;
  public deviceoncouple:boolean=false;
  public SecondDevicewithFrame: boolean;
  public selectedDrivenAssetType: any = "";
  public imgSrc = "";
  public img2src = "";
  public masterselected: any;


  public primaryDevice = {
    "primary": {
      "device": "",
      "master": "",
      "sensors": {
        "frame": { "use": false, "id": "", "bg": "#fff", "label": "S", "status": "INPROCESS" },
        "de": { "use": false, "id": "", "bg": "#fff", "label": "S", "status": "INPROCESS" },
        "nde": { "use": false, "id": "", "bg": "#fff", "label": "S", "status": "INPROCESS" },
        "couple": { "use": false, "id": "", "bg": "#fff", "label": "S", "status": "INPROCESS" }
        
      }
    },
    "secondary": {
      "device": "",
      "sensors": {
        
        "frame": { "use": false, "id": "", "bg": "#fff", "label": "S", "status": "INPROCESS" },
        "de": { "use": false, "id": "", "bg": "#fff", "label": "S", "status": "INPROCESS" },
        "nde": { "use": false, "id": "", "bg": "#fff", "label": "S", "status": "INPROCESS" }
      }
    }
  };
  public subAssetType: string ="MOTOR";
  public selectedMotor: string = "IM";
  fromboiler: any;



  constructor(
    private spinner: NgxSpinnerService,
    private service: BackendApiService,
    public router: Router,
    public dialogRef: MatDialogRef<DefineAssetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {},
    private _formBuilder: FormBuilder,
    public dialog: MatDialog,
  ) {
    console.log(data['boiler'],'data11')
    data['boiler'] == undefined ? this.fromboiler = "" : this.fromboiler = data['boiler'];
    // if(data['boiler']== undefined){
    //   this.fromboiler ="";
    // }else{
    //   this.fromboiler = data['boiler'];
    // }
    console.log(this.fromboiler,'forboiler')
    dialogRef.disableClose=true;
  }

  ngOnInit() {
    this.selecteddevice = "MOTOR";
    this.onDeviceChange('MOTOR', '')
    this.selecteddevicewithmotor = "";
    this.primaryDevice.secondary.device = "";
  }
  onassignmaster(event) {
    this.primaryDevice.primary.master = this.masterselected;
  }

  onContinuecheck() {
  }
  onclickcontinue() {
    let templateObject: any = {};
    templateObject.device_pri = this.primaryDevice.primary.device;
    templateObject.device_sec = this.primaryDevice.secondary.device;
    
    if (templateObject.device_sec == "") {
      this.primaryDevice.secondary.sensors.frame.use = false
      this.primaryDevice.secondary.sensors.de.use = false
      this.primaryDevice.secondary.sensors.nde.use = false
    }
    templateObject.template_id = 1;
    templateObject.device = this.primaryDevice;
    let template = templateObject;
    console.log(template,'templateeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
    template.primarydevice = this.primaryDevice;

    
    if (template !== undefined && this.primaryDevice.primary.master !== "") {
      const navigationExtras = {
        skipLocationChange: true,
        state: {
          templateSelection: template,
          selecteddevice: this.selecteddevice,
          selecteddevicewithmotor: this.selecteddevicewithmotor,
          SecondDevicewithFrame: this.SecondDevicewithFrame,
          SecondDevicewithNDE: this.SecondDevicewithNDE,
          DeviceonCouple:this.deviceoncouple,
          SecondDevicewithDE: this.SecondDevicewithDE,
          devicewithDE: this.devicewithDE,
          devicewithNDE: this.devicewithNDE,
          devicewithFrame: this.devicewithFrame,
          fromBoiler:this.fromboiler,
          orientation: this.isHorizontalView ? 'horizontal' : 'vertical',
        }
      };
      if (templateObject.device_sec === '' &&(this.devicewithDE || this.devicewithNDE || this.devicewithFrame || this.deviceoncouple)){
        if(this.selectedMotor ==='' && this.selectedAssetType === 'MOTOR'){
          this.dialog.open(DefineErrorComponent, {
            width: '400px',
            maxWidth: '85vw',
            data: {
              Errornotmastertesslected: "Please select motor type."
            }
          });
        }else 
        {
          this.closeDialog();
          this.router.navigate(['/clients-add-assets'], navigationExtras);
        } 
      }else if (templateObject.device_sec !== '' && (this.deviceoncouple || this.SecondDevicewithFrame || this.SecondDevicewithNDE || this.SecondDevicewithDE)) 
        {
          if(this.selectedMotor ==='' && this.selectedAssetType === 'MOTOR'){
            this.dialog.open(DefineErrorComponent, {
              width: '400px',
              maxWidth: '85vw',
              data: {
                Errornotmastertesslected: "Please select motor type."
              }
            });
          }else{
            this.closeDialog();
            this.router.navigate(['/clients-add-assets'], navigationExtras);
          }
        } 
        else {
          this.dialog.open(DefineErrorComponent, {
            width: '400px',
            maxWidth: '85vw',
            data: {
              Errornotmastertesslected: "Please select the sensor for driven device"
            }
          });
        }
    } 
   
    else if (this.devicewithDE || this.devicewithNDE || this.devicewithFrame || this.deviceoncouple) {
      this.dialog.open(DefineErrorComponent, {
        width: '400px',
        maxWidth: '85vw',
        data: {
          Errornotmastertesslected: "Please select the sensor to be consider as master device"
        }
      });
    }
    
    
    else if (!this.devicewithDE && !this.devicewithNDE && !this.devicewithFrame && !this.deviceoncouple) {
      this.dialog.open(DefineErrorComponent, {
        width: '400px',
        maxWidth: '85vw',
        data: {
          Errornotmastertesslected: "Please select the sensor"
        }
      });
    }

    else {
      this.dialog.open(DefineErrorComponent, {
        width: '400px',
        maxWidth: '85vw',
        data: {
          Errornotmastertesslectedd: "Something went wrong, please try again!"
        }
      });
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
  onclickclose() {
    this.closeDialog();
  }
  removeUserImage() {
    this.service.getData(this.imageUploadUrl + "/remove/asset/" + this.assetsID).then(response => {
      this._imgUrl = "./assets/img-new/default_user.png";
      this.service.showSuccess('Removed successfully.');
    })
  }
  /** Secondary device dropdown change event */
  onDrivenChange(value, event) {
    switch (value) {
      case "MOTOR":
        this.primaryDevice.secondary.device = this.selectedDrivenAssetType = "MOTOR";
        this.img2src = './assets/motor_n.png'
        break;
      case "GEAR BOX":
        this.primaryDevice.secondary.device = this.selectedDrivenAssetType = "GEAR";
        this.img2src = './assets/gearbox.png'
        break;
      case "PUMP":
        this.primaryDevice.secondary.device = this.selectedDrivenAssetType = "PUMP";
        this.img2src = './assets/pump.png'
        break;
      case "FAN/BLOWER":
        this.primaryDevice.secondary.device = this.selectedDrivenAssetType = "FAN_BLOWER";
        this.img2src = './assets/fan.png'
        break;
      case "COMPRESSOR":
        this.primaryDevice.secondary.device = this.selectedDrivenAssetType = "COMPRESSOR";
        this.img2src = './assets/compressor.png'
        break;
      case "JOURNALBEARING":
        this.primaryDevice.secondary.device = this.selectedDrivenAssetType = "JOURNAL_BEARING";
        this.img2src = './assets/bearing2.png'
        break;
    }
  }

  onRadiobuttonSelect(value:string){
    // this.selectedAssetType =value;
    this.selectedMotor = value;
    this.onDeviceChange(this.selectedAssetType, '');
  }

  /** Primary device dropdown change event */
  onDeviceChange(value: string, event: any) {
    switch (value) {
      case "MOTOR":
        this.subAssetType = 'MOTOR';
        switch (this.selectedMotor) {
          case "IM": 
            this.primaryDevice.primary.device = "INDUCTION_MOTOR";
            this.selectedAssetType = "MOTOR";
            this.imgSrc = './assets/motor_n.png';
            break;
          
          case "DC":
            console.log('Dc')
            this.primaryDevice.primary.device = "DC_MOTOR";
            this.selectedAssetType = "MOTOR";
            this.imgSrc = './assets/motor_n.png';
            break;

          case "SM": 
            this.primaryDevice.primary.device = "SYNCHRONOUS_MOTOR";
            this.selectedAssetType = "MOTOR";
            this.imgSrc = './assets/motor_n.png';
            break;

          case "ALT":
            this.primaryDevice.primary.device = "ALTERNATOR";
            this.selectedAssetType = "MOTOR";
            this.imgSrc = './assets/motor_n.png';
            break;
          
          case "":
            this.primaryDevice.primary.device = "MOTOR";
            this.selectedAssetType = "MOTOR";
            this.imgSrc = './assets/motor_n.png';
            break;
        }
        
        break;
      case "GEAR BOX":
        this.subAssetType = 'GEAR'
        this.primaryDevice.primary.device = this.selectedAssetType = "GEAR";
        this.imgSrc = './assets/gearbox.png'
        break;
      case "PUMP":
        this.subAssetType = 'PUMP';
        this.primaryDevice.primary.device = this.selectedAssetType = "PUMP";
        this.imgSrc = './assets/pump.png'
        break;
      case "FAN/BLOWER":
        this.subAssetType = "FAN_BLOWER";
        this.primaryDevice.primary.device = this.selectedAssetType = "FAN_BLOWER";
        this.imgSrc = './assets/fan.png'
        break;
      case "COMPRESSOR":
        this.subAssetType = "COMPRESSOR";
        this.primaryDevice.primary.device = this.selectedAssetType = "COMPRESSOR";
        this.imgSrc = './assets/compressor.png'
        break;
      case "JOURNALBEARING":
        this.subAssetType = "JOURNAL_BEARING";
        this.primaryDevice.primary.device = this.selectedAssetType = "JOURNAL_BEARING";
        this.imgSrc = './assets/bearing2.png'
        break;
    }
  }
  /** Checkbox change event */
  onchange(event: any) {
    let count = 0;
    if (event.checked) {
      count++
    }
    else {
      count--
    }
    console.log(event.source.id,'event.source.id')
    switch (event.source.id) {
      case "frame_primary":
        //console.log(event.checked,"frame primary")
        this.primaryDevice.primary.sensors.frame.use = this.devicewithFrame = event.checked;
       
        if (count == 1) {
          this.masterselected = "frame";
          this.primaryDevice.primary.master = this.masterselected
        }
        break;
      case "de_primary":
        this.primaryDevice.primary.sensors.de.use = this.devicewithDE = event.checked;
        if (count == 1) {
          this.masterselected = "de";
          this.primaryDevice.primary.master = this.masterselected
        }
        break;
      case "nde_primary":
        this.primaryDevice.primary.sensors.nde.use = this.devicewithNDE = event.checked;
        if (count == 1) {
          this.masterselected = "nde";
          this.primaryDevice.primary.master = this.masterselected
        }
        break;
      case "frame_secondary":
        this.primaryDevice.secondary.sensors.frame.use = this.SecondDevicewithFrame = event.checked;
        break;
      case "de_secondary":
        this.primaryDevice.secondary.sensors.de.use = this.SecondDevicewithDE = event.checked;
        break;
      case "nde_secondary":
        this.primaryDevice.secondary.sensors.nde.use = this.SecondDevicewithNDE = event.checked;
        break;
        case "Couple":
          this.opensecondimage==true
          this.primaryDevice.primary.sensors.couple.use = this.deviceoncouple = event.checked;
          // if(!event.checked){
          //   this.masterselected = "";
          //   this.primaryDevice.primary.master = this.masterselected
          // }

          if (count == 1) {
            this.masterselected = "couple";
            this.primaryDevice.primary.master = this.masterselected
          }
         
          if(this.opensecondimage==true && event.checked==false){
            this.masterselected = "";
           this.primaryDevice.primary.master = this.masterselected
            event.checked=true;
            this.onyesno(event);
            event.checked=false;
          }
          else{
            this.onyesno(event);
          }
          
        
        break;
    }
  }
  onyesno(event) {
    if (event.checked) {
      this.opensecondimage = true;
      this.selecteddevicewithmotor = 'GEAR BOX';
      this.onDrivenChange('GEAR BOX', 'click_event');
    }
    else {
      this.primaryDevice.primary.sensors.couple.use = this.deviceoncouple = event.checked;
      // if(this.masterselected = "couple"){
      //   this.masterselected = "";
      //   this.primaryDevice.primary.master = this.masterselected
      // }
      
      this.opensecondimage = false;
      this.ngOnInit();
    }

  }
}


